export const IMPORT_FILE_MAX_BYTES = 20 * 1024 * 1024;

/** At most 20 Mo. No file passes: `isImportFileSelected` reports that case. */
function isImportFileSizeAccepted(value: File | null): boolean {
	return value === null || value.size <= IMPORT_FILE_MAX_BYTES;
}

export default isImportFileSizeAccepted;
